import React, {useEffect, useMemo, useState} from 'react';
import Title from 'antd/lib/typography/Title';
import TextArea from 'antd/lib/input/TextArea';
import {Button, Divider, Popconfirm, Select, Space} from 'antd';
import {SubmissionApi, SubmissionDto, SubmissionStatus, UserApi, UserRole} from '../../scaffold';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function SubmissionDistribute(props: {submission: SubmissionDto; refresh: () => any}) {
  const isJudge = props.submission.status === SubmissionStatus.待分配盲审;
  const isSupervisor = props.submission.status === SubmissionStatus.待分配督导;
  const isChecker = props.submission.status === SubmissionStatus.待分配论文初审;
  const listUser = useOpenApiFpRequest(UserApi, UserApi.prototype.userListGet);
  const distributeSupervisor = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionDistributeSupervisorPost);
  const distributeJudge = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionDistributeJudgerPost);
  const distributeChecker = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionDistributeCheckerPost);
  const [userId, setUserId] = useState<number>();
  useEffect(() => {
    listUser.requestSync({});
  }, []);
  const userList = listUser.data?.filter(u => {
    if (isJudge) return u.role === UserRole.教师 && u.isJudge;
    if (isChecker) return u.role === UserRole.教师 && u.isChecker;
    return u.role === UserRole.教师 && u.isSupervisor;
  });
  const teacherType = useMemo(() => {
    if (isJudge) return '盲审';
    if (isSupervisor) return '督导';
    return '论文初审';
  }, [isJudge, isSupervisor, isChecker]);
  return (
    <div>
      <Title level={3}>分配 {teacherType}</Title>
      <div>
        <Select value={userId} onChange={setUserId} style={{width: 200}} placeholder={'请选择' + teacherType}>
          {userList?.map(u => (
            <Select.Option key={u.id} value={u.id as number}>
              {u.name}
            </Select.Option>
          ))}
        </Select>
      </div>
      <Popconfirm
        title={'确认分配' + teacherType + '吗'}
        onConfirm={() => {
          if (isJudge) {
            distributeJudge
              .request({
                submissionDistributeJudgerModel: {
                  id: props.submission.id,
                  judgerId: userId || 0,
                },
              })
              .then(props.refresh)
              .catch(CommonApiErrorHandler);
          } else if (isSupervisor) {
            distributeSupervisor
              .request({
                submissionDistributeSupervisorModel: {
                  id: props.submission.id,
                  supervisorId: userId || 0,
                },
              })
              .then(props.refresh)
              .catch(CommonApiErrorHandler);
          } else if (isChecker) {
            distributeChecker
              .request({
                submissionDistributeCheckerModel: {
                  id: props.submission.id,
                  checkerId: userId || 0,
                },
              })
              .then(props.refresh)
              .catch(CommonApiErrorHandler);
          }
        }}>
        <Button
          className={'m-t-10'}
          type={'primary'}
          loading={distributeSupervisor.loading || distributeJudge.loading || distributeChecker.loading}
          disabled={!userId}>
          确认分配
        </Button>
      </Popconfirm>
      <Divider />
    </div>
  );
}
